module.exports = __webpack_public_path__ + "assets/artisan1w.7be6f63e6326f3087588074a0506e332.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/artisan1w.png
 ** module id = 186
 ** module chunks = 0
 **/